import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EmailService } from '@app-service/email-service.service';
@Component({
    selector: 'freedom-dailog',
    templateUrl: './freedom-dailog.component.html',
    styleUrls: ['./freedom-dailog.component.scss'],
    standalone: false
})
export class FreedomDailogComponent implements OnInit {
  secondScreen : boolean = false;
  url;
  constructor(
    private dialogRef: MatDialogRef<FreedomDailogComponent>,
    private emailService : EmailService,
    @Inject(MAT_DIALOG_DATA) data) {
  }

  ngOnInit(): void {
  }


  closeDialog(): void {
    this.dialogRef.close();
  }

  requestDemo(): void {
    this.secondScreen = true;
    this.emailService.sendLeadOnEmail(); //call emailjs service
  }

  goToFreedom():void {
    window.open('https://www.enkash.com/corporate-cards/', '_blank');
    this.closeDialog();
  }
}
